import SVG from "@Components/Icons/SVG";
export default class UiTooltip extends SVG {
    fill = "var(--primary-color)";
    path = [
        "M 50 0 A 1 1 0 0 0 50 100 A 1 1 0 0 0 50 0 M 43 10 C 42 10 41 11 41 12 L 41 22 C 41 23 42 24 43 24 L 57 24 C 58 24 59 23 59 22 L 59 12 C 59 11 58 10 57 10 L 43 10 M 59 36 C 59 35 58 34 57 34 L 35 34 C 34 34 33 35 33 36 L 33 46 C 33 47 34 48 35 48 L 39 48 C 40 48 41 49 41 50 L 41 67 C 41 68 40 69 39 69 L 35 69 C 34 69 33 70 33 71 L 33 81 C 33 82 34 83 35 83 L 65 83 C 66 83 67 82 67 81 L 67 71 C 67 70 66 69 65 69 L 61 69 C 60 69 59 68 59 67 L 59 36",
    ];
    evenOdd = true;
}
